/* eslint-disable */
import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright © <span id="year"></span> ResMax Power Tech. All
                rights reserved.
              </div>
            </div>
          </div>
        </footer>
        <a href="#top" id="back-to-top">
          <i className="fa fa-angle-up"></i>
        </a>
      </div>
    );
  }
}

export default Footer;
